const defaultEventProjection = [
  'archive',
  'category_id',
  'category_name',
  'category',
  'course_id',
  'courseAudience',
  'course_name',
  'credits',
  'delivery_date',
  'delivery_end_date',
  'delivery_location_time_zone_id',
  'delivery_location',
  'delivery_method',
  'end_time',
  'event_id',
  'fieldOfStudyDept',
  'firmOnly',
  'hours',
  'instructors',
  'inviteOnly',
  'link',
  'locations',
  'max_participants',
  'name',
  'price',
  'priceText',
  'start_time',
  'tags',
  'timeZoneId',
  'vendor_id'
];

export { defaultEventProjection };



//////////////////
// WEBPACK FOOTER
// ./src/assets/projections/index.js
// module id = 92
// module chunks = 0